class Accordions {
    constructor(sel) {
        // view
        this.components = document.querySelectorAll(sel);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(comp => {
            this.initQuestions(comp);
        });
    }

    initQuestions(comp) {
        const questions = comp.querySelectorAll('li');
        questions.forEach(faq => {
            faq.addEventListener('click', () => {
                const isActive = faq.classList.contains('active');

                if (!isActive) {
                    this.closeAll(comp, faq);
                    this.updateImage(comp, faq); 
                }

                faq.classList.toggle('active');
            });
        });

        if (questions[0]) {
            questions[0].click();
        }
    }

    closeAll(comp, currentFaq) {
        const questions = comp.querySelectorAll('li');
        questions.forEach(faq => {
            if (faq !== currentFaq && faq.classList.contains('active')) {
                faq.classList.remove('active');
            }
        });
    }

    updateImage(comp, item) {
        let image = item.dataset.image;
        let description = item.querySelector("h3");
        let textContent = description.textContent || "";
        let figure = comp.querySelector(".img-box");
        if (image) figure.innerHTML = `<img src="${image}" alt="${textContent}" />`
    }
}

const accordions = new Accordions(".accordions-images");
